import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function SettingsBreadcrumb({ items = [], current }) {
  if (!items.length && !current) return null;
  return (
    <nav aria-label="Percorso Impostazioni" className="mb-3 flex min-w-0 items-center gap-1 text-xs text-stone-500">
      {items.map((item, index) => (
        <React.Fragment key={`${item.label}-${index}`}>
          {index > 0 && <ChevronRight className="h-3.5 w-3.5 shrink-0 text-stone-300" aria-hidden="true" />}
          {item.to ? (
            <Link to={item.to} className="truncate hover:text-brand-blue hover:underline">{item.label}</Link>
          ) : (
            <span className="truncate">{item.label}</span>
          )}
        </React.Fragment>
      ))}
      {current && (
        <>
          {items.length > 0 && <ChevronRight className="h-3.5 w-3.5 shrink-0 text-stone-300" aria-hidden="true" />}
          <span className="truncate font-semibold text-stone-700" aria-current="page">{current}</span>
        </>
      )}
    </nav>
  );
}